<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <leave-credits>
        </leave-credits> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import leaveCredits from './todo-leave-credits'
export default {
    components: {
        leaveCredits
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-leave-credits.vue